export const FETCH_PRODUCTS_BEGIN   = 'FETCH_PRODUCTS_BEGIN';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';

const fetchProductsBegin = () => ({
  type: FETCH_PRODUCTS_BEGIN
});

const fetchProductsSuccess = products => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: { ...products }
});

const fetchProductsFailure = error => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: { error }
});

function fetchProducts( ) {
	return dispatch => {
		
		dispatch(fetchProductsBegin());
		
		return fetch("http://scratch.sahalatec.com")
			.then(res => res.json())
			.then(products => {
				console.log(products,"abcddd");
				dispatch( fetchProductsSuccess(products) );
				return products;
			})
			.catch(error => dispatch(fetchProductsFailure(error)));
	};
}

export {
	fetchProducts,
	fetchProductsBegin,
	fetchProductsSuccess,
	fetchProductsFailure	
}